class CustomBundleWidget {
  constructor(originalWidget, targetForm, productVariantsJson) {
    this.original = originalWidget;
    this.form = targetForm;
    this.variants = productVariantsJson;
    this.options = [];
    this.selectionMemory = {};
    this.activeBundleIndex = null;
    this.bundleGroups = [];
    this.init();
  }

  init() {
    this.extractData();
    this.renderCustomUI();
    this.bindQuantityEvents();
    this.observePriceChanges();
    this.hideOriginalElements();
  }

  extractData() {
    const blocks = this.original.querySelectorAll('.block__cb');
    this.options = [...blocks].map((block) => ({
      id: block.querySelector('input[type=radio]').id,
      quantityText: block.querySelector('div[class$="cbmain--content--left__top"] h5').textContent.trim(),
      discountText: block.querySelector('div[class$="cbmain--content--left__top"] h4') && block.querySelector('div[class$="cbmain--content--left__top"] h4').textContent.trim() || "Standard Price",
      selects: [...block.querySelectorAll('select')].map((select) => ({
        original: select,
        options: [...select.options].map((o) => ({
          value: o.value,
          text: o.textContent.trim(),
        })),
      })),
    }));

    this.options.forEach((opt, idx) => {
      this.selectionMemory[idx] = opt.selects.map((s) => s.original.value);
    });
  }

  renderCustomUI() {
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-bundle-widget max-w-lg mx-auto';

    this.widgetTitle = document.createElement('h3');
    this.widgetTitle.className = 'custom-bundle-widget-title';
    this.widgetTitle.innerHTML = 'Buy more and save more';
    wrapper.appendChild(this.widgetTitle);

    // Botones de cantidad
    this.quantityContainer = document.createElement('div');
    this.quantityContainer.className = 'custom-bundle-widget-quantities';

    this.options.forEach((opt, index) => {
      const quantity = parseInt(opt.quantityText);
      const label = quantity === 1 ? 'item' : 'items';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-bundle-widget-quantity-btn';
      btn.dataset.index = index;
      btn.innerHTML = `
        <span class="qty-number">${quantity} ${label}</span>
        <span class="qty-discount ${
          opt.discountText === 'Standard Price' ? 'standard' : 'has-discount'
        }">${opt.discountText || 'Standard price'}</span>
      `;

      this.quantityContainer.appendChild(btn);
    });
    wrapper.appendChild(this.quantityContainer);

    // Contenedor de selectores de productos
    this.productSelectorContainer = document.createElement('div');
    this.productSelectorContainer.className = 'custom-bundle-widget-product-selectors';
    this.bundleGroups = [];

    this.options.forEach((bundle, index) => {
      const memory = this.selectionMemory[index] || [];
      const bundleGroupWrapper = document.createElement('div');
      bundleGroupWrapper.className = 'custom-bundle-group';
      
      bundleGroupWrapper.style.display = index === 0 ? 'block' : 'none';

      bundle.selects.forEach((selInfo, sIdx) => {
        const currentValue = memory[sIdx] || selInfo.original.value;
        const currentOption = selInfo.options.find((o) => o.value === currentValue);
        const variantName = currentOption?.text || '';

        const groupWrapper = document.createElement('div');
        groupWrapper.className = 'custom-bundle-widget-select-group';
        groupWrapper.dataset.index = sIdx;

        const groupTitle = document.createElement('strong');
        groupTitle.className = 'custom-bundle-widget-group-title';
        groupTitle.textContent = `Item ${sIdx + 1}: ${variantName}`;
        groupWrapper.appendChild(groupTitle);

        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'custom-bundle-widget-variant-buttons';

        const prices = selInfo.options.map((opt) => this.findVariant(opt.value)?.price || '0');
        const allSamePrice = prices.every((p) => p === prices[0]);
        if (allSamePrice) buttonContainer.classList.add('same-price');

        selInfo.options.forEach((opt) => {
          const varData = this.findVariant(opt.value);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'custom-bundle-widget-select-btn';
          btn.dataset.value = opt.value;

          btn.innerHTML = `
            <img src="${varData?.image || ''}" alt="${opt.text}" class="custom-bundle-widget-select-img">
            <span class="custom-bundle-widget-select-text">${opt.text}</span>
            <span class="custom-bundle-widget-select-price">${varData?.price || '0'}</span>
          `;

          if (!varData?.available) btn.disabled = true;
          if (currentValue === opt.value) btn.classList.add('active');

          btn.addEventListener('click', () => {
            this.updateOriginalSelect(index, sIdx, opt.value);
            buttonContainer.querySelectorAll('button').forEach((b) => b.classList.remove('active'));
            btn.classList.add('active');
            groupTitle.textContent = `Item ${sIdx + 1}: ${opt.text}`;
          });

          buttonContainer.appendChild(btn);
        });

        groupWrapper.appendChild(buttonContainer);
        bundleGroupWrapper.appendChild(groupWrapper);
      });

      this.bundleGroups.push(bundleGroupWrapper);
      this.productSelectorContainer.appendChild(bundleGroupWrapper);
    });

    wrapper.appendChild(this.productSelectorContainer);

    // Precio
    this.priceContainer = document.createElement('div');
    this.priceContainer.className = 'custom-bundle-widget-price-container';
    this.priceContainer.innerHTML = `
      <strong class="custom-bundle-widget-price-amount">$0</strong>
      <span class="custom-bundle-widget-price-original" style="text-decoration:line-through;display:none;margin-left:8px;color:#0C0D0D;opacity:0.2;">$0</span>
    `;
    wrapper.appendChild(this.priceContainer);

    this.form.prepend(wrapper);

    this.widget = wrapper;
  }

  bindQuantityEvents() {
    this.quantityContainer.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = +btn.dataset.index;
        this.selectBundle(idx);
      });
    });
    this.selectBundle(0);
  }

  selectBundle(index) {
    if (this.activeBundleIndex !== null) this.saveSelections(this.activeBundleIndex);
    this.activeBundleIndex = index;

    this.original.querySelector(`#${this.options[index].id}`)?.click();

    this.quantityContainer.querySelectorAll('button').forEach((b) =>
      b.classList.toggle('active', +b.dataset.index === index)
    );

    this.bundleGroups.forEach((group, i) => {
      group.style.display = i === index ? 'block' : 'none';
    });
  }

  saveSelections(idx) {
    const blk = this.options[idx];
    this.selectionMemory[idx] = blk.selects.map((s) => s.original.value);
  }

  updateOriginalSelect(bIdx, sIdx, val) {
    // Paso 1: actualiza selects de todos los grupos menos el activo
    this.options.forEach((option, bundleIdx) => {
      if (bundleIdx !== bIdx && option.selects[sIdx]) {
        const sel = option.selects[sIdx].original;
        sel.value = val;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        if (!this.selectionMemory[bundleIdx]) this.selectionMemory[bundleIdx] = [];
        this.selectionMemory[bundleIdx][sIdx] = val;
      }
    });

    // Paso 2: actualiza solo el select del grupo activo al final
    const activeSelect = this.options[bIdx]?.selects[sIdx]?.original;
    if (activeSelect) {
      activeSelect.value = val;
      activeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      if (!this.selectionMemory[bIdx]) this.selectionMemory[bIdx] = [];
      this.selectionMemory[bIdx][sIdx] = val;
    }

    // Actualiza UI
    this.widget
      .querySelectorAll(`.custom-bundle-widget-select-group[data-index="${sIdx}"]`)
      .forEach((matchedSelector) => {
        matchedSelector.querySelector('button.active')?.classList.remove('active');
        const btnToActivate = matchedSelector.querySelector(`button[data-value="${val}"]`);
        if (btnToActivate) btnToActivate.classList.add('active');

        const text = btnToActivate?.querySelector('.custom-bundle-widget-select-text')?.textContent;
        if (text) {
          const groupTitle = matchedSelector.querySelector('.custom-bundle-widget-group-title');
          if (groupTitle) {
            const indexText = groupTitle.textContent.split(':')[0];
            groupTitle.textContent = `${indexText}: ${text}`;
          }
        }
      });

    //Actualiza la imagen de la variaante seleccionada
    this.originalVariantBlock && this.originalVariantBlock.querySelector(`input[value="${val}"]`) && this.originalVariantBlock.querySelector(`input[value="${val}"]`).click();

  }



  findVariant(value) {
    return this.variants.find((v) => v.title === value) || {};
  }

  observePriceChanges() {
    const updatePrice = () => {
      const activeRadio = this.original.querySelector('input[type="radio"]:checked');
      if (!activeRadio) return;

      const index = [...this.original.querySelectorAll('input[type="radio"]')].indexOf(activeRadio);
      const totalPriceEl = this.original.querySelector(`.bottomtitle__totalPrice__container`);
      const originalPriceEl = this.original.querySelector(`#prvw_originalAmount_${index}`);

      const priceText = totalPriceEl?.textContent?.trim().replace(' ', '') || '';
      const compareText = originalPriceEl?.textContent?.trim().replace(' ', '') || '';

      const customPrice = this.priceContainer.querySelector('.custom-bundle-widget-price-amount');
      const customCompare = this.priceContainer.querySelector('.custom-bundle-widget-price-original');

      customPrice.textContent = priceText;
      if (compareText) {
        customCompare.textContent = compareText;
        customCompare.style.display = 'inline';
      } else {
        customCompare.style.display = 'none';
      }

      const mainPriceEl = document.querySelector('.product-content-container [data-product-price]');
      
      if (mainPriceEl) {
        mainPriceEl.classList.add('hidden');

        let auxPrice;
        if(mainPriceEl.parentElement.querySelector('.aux-price')){
          auxPrice = mainPriceEl.parentElement.querySelector('.aux-price');
        } else {
          auxPrice = document.createElement('span');
          auxPrice.classList.add('aux-price');
          mainPriceEl.parentElement.appendChild(auxPrice);
        }

        if (compareText) {
          auxPrice.innerHTML = `${priceText} <s class="compare-price" style="margin-left:8px;color:#0C0D0D;opacity:0.2;">${compareText}</s>`;
        } else {
          auxPrice.textContent = priceText;
        }
      }
    };

    updatePrice();
    const priceObserver = new MutationObserver(() => updatePrice());
    priceObserver.observe(this.original, { childList: true, subtree: true });
    this.original.addEventListener('change', updatePrice);
  }

  hideOriginalElements() {
    this.original.classList.add('hidden');
    this.originalVariantBlock = document.querySelector('.product-content-container .product-variant-picker-block');
    if (this.originalVariantBlock) {
      this.originalVariantBlock.classList.add('hidden');
    }
  }
}

// ==============================
// 2. INICIALIZACIÓN DEL WIDGET
// ==============================
const productData = JSON.parse(
  document.getElementById('product-variants-json').textContent
);
const form = document.querySelector('.product-content-container .product-form');

const observer = new MutationObserver((mutations, obs) => {
  const widgetInForm = mutations.some((mutation) =>
    [...mutation.addedNodes].some((node) =>
      node.nodeType === 1 &&
      (node.id === 'prvw__bundle_container' || node.querySelector?.('#prvw__bundle_container')) &&
      form.contains(document.querySelector('#prvw__bundle_container'))
    )
  );

  if (widgetInForm) {
    obs.disconnect();
    new CustomBundleWidget(form.querySelector('#prvw__bundle_container'), form, productData);
  }
});

if (form) {
  observer.observe(form, { childList: true, subtree: false });

  setTimeout(() => {
    console.warn('⏳ Widget no se encontró después de 1 minuto. Deteniendo observer.');
    observer.disconnect();
  }, 60000);
}